(function(){
    angular
        .module('maApp.error')
        .factory('RequestError', RequestError);

    RequestError.$inject = [];

    function RequestError(){

        var _PBRequestError;

        function createRequestErrorObject(){
            RequestError.prototype = Object.create(Error.prototype);
            RequestError.prototype.constructor = RequestError;

            return RequestError;

            function RequestError(response, message){
                Error.call(this);
                this.name = 'RequestError';
                this.message = message;
                this.response = response;
            }
        }

        if(!_PBRequestError){
            _PBRequestError =  createRequestErrorObject();
        }

        return _PBRequestError;
    }
})();